import PropTypes from 'prop-types';
import { equals, path } from 'ramda';
import React, { Component } from 'react';
import { FeatureGroup, Popup, GeoJSON } from 'react-leaflet';
import { connect } from 'react-redux';

import Button from '@material-ui/core/Button';

import { openLeftBarModule } from '../modules/actions/layout';
import { routeBlockageDetailOpen } from '../modules/actions/routeBlockageDetail';


class RouteBlockageFeature extends Component {
  static propTypes = {
    // Own props.
    id: PropTypes.string.isRequired,
    stops: PropTypes.shape({}).isRequired,
    routeBlockage: PropTypes.shape({}).isRequired,

    // Dispatch props.
    openLeftBarModule: PropTypes.func.isRequired,
    routeBlockageDetailOpen: PropTypes.func.isRequired,
  };

  shouldComponentUpdate(nextProps, nextState) {
    const { routeBlockage: oldRouteBlockage, stops: oldStops } = this.props;
    const { routeBlockage: newRouteBlockage, stops: newStops } = nextProps;

    /**
     * Update when the stops change.
     */
    const osf = path(['relationships', 'stop-from', 'data', 'id'], oldRouteBlockage);
    const ost = path(['relationships', 'stop-to', 'data', 'id'], oldRouteBlockage);
    const nsf = path(['relationships', 'stop-from', 'data', 'id'], newRouteBlockage);
    const nst = path(['relationships', 'stop-to', 'data', 'id'], newRouteBlockage);
    if (osf !== nsf) return true;
    if (ost !== nst) return true;

    /**
     * Update when the stop names change.
     */
    const osfn = path([osf, 'attributes', 'name'], oldStops);
    const ostn = path([ost, 'attributes', 'name'], oldStops);
    const nsfn = path([nsf, 'attributes', 'name'], newStops);
    const nstn = path([nst, 'attributes', 'name'], newStops);
    if (osfn !== nsfn) return true;
    if (ostn !== nstn) return true;

    /**
     * Update when the required or active vehicle count changes.
     */
    const ovr = path(['attributes', 'vehicles-required'], oldRouteBlockage);
    const ova = path(['relationships', 'rides', 'meta', 'count'], oldRouteBlockage);
    const nvr = path(['attributes', 'vehicles-required'], newRouteBlockage);
    const nva = path(['relationships', 'rides', 'meta', 'count'], newRouteBlockage);
    if (ovr !== nvr) return true;
    if (ova !== nva) return true;

    /**
     * Update when geojson becomes available or changes.
     */
    const ogj = path(['attributes', 'geojson'], oldRouteBlockage);
    const ngj = path(['attributes', 'geojson'], newRouteBlockage);
    if (!ogj && ngj) return true;
    if (ogj && ngj && !equals(ogj, ngj)) return true;

    /**
     * Otherwise, don't update.
     */
    return false;
  };

  render () {
    const {
      routeBlockage,
      stops,
      openLeftBarModule,
      routeBlockageDetailOpen,
      isAdmin,
    } = this.props;

    let geom = path(['attributes', 'geojson'], routeBlockage);

    if (!geom) {
      console.error('RouteBlockageFeature.render(' + routeBlockage.id + '): no geojson!');
      return null;
    }

    /**
     * XXX it appears creating new RouteBlockages return the object with
     * geojson serialized as string rather than just another JSON object.
     */
    if (typeof geom === 'string') {
      console.warn('RouteBlockageFeature.render(' + routeBlockage.id + '): `geojson` attribute serialized as string');
      geom = JSON.parse(geom);
    }

    const stop_from_id = path(['relationships', 'stop-from', 'data', 'id'], routeBlockage) || 'noSuchStop';
    const stop_to_id = path(['relationships', 'stop-to', 'data', 'id'], routeBlockage) || 'noSuchStop';
    const stop_from_name = path([stop_from_id, 'attributes', 'name'], stops) || 'Onbekend';
    const stop_to_name = path([stop_to_id, 'attributes', 'name'], stops) || 'Onbekend';
    const key = stop_from_id + ':' + stop_to_id;

    const vehicles_required = path(['attributes', 'vehicles-required'], routeBlockage) || 0;
    const vehicles_active = path(['relationships', 'rides', 'meta', 'count'], routeBlockage) || 0;

    return (
      <FeatureGroup>
        <Popup className="route-blockage-feature-popup">
          <span>{'Stremming van ' + stop_from_name + ' naar ' + stop_to_name}</span>
          <br />
          <span>{'Aantal bussen: ' + vehicles_active + '/' + vehicles_required}</span>
          <br />
          {isAdmin &&
            <div onClick={() => openLeftBarModule('routeBlockage', 'routeBlockageEdit', {type: 'edit', id: routeBlockage.id})}>
              <Button color="primary">Wijzigen</Button>
            </div>
          }

          <div onClick={() => routeBlockageDetailOpen(routeBlockage.id)}>
            <Button color="secondary">Details</Button>
          </div>
        </Popup>
        <GeoJSON key={key} data={geom} style={{ weight: 4, color: '#FF0000' }} />
      </FeatureGroup>
    );
  }
}

const mapDispatchToProps = {
  openLeftBarModule,
  routeBlockageDetailOpen,
};

export default connect(null, mapDispatchToProps)(RouteBlockageFeature);
